import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  justify-content: space-evenly;
  & > * {
    width: 100%;
    flex: 1;
  }
`;

export const Table = styled.table`
  width: 100%;
  & tr th {
    padding-bottom: 10px;
    width: 20%;
  }
  & tr td {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 20%;
    text-align: end;
  }

  & tr th:first-of-type,
  tr td:first-of-type {
    text-align: start;
  }
`;